import { render, staticRenderFns } from "./CashbackTag.vue?vue&type=template&id=1ac7f132&scoped=true"
import script from "./CashbackTag.vue?vue&type=script&lang=js"
export * from "./CashbackTag.vue?vue&type=script&lang=js"
import style0 from "./CashbackTag.vue?vue&type=style&index=0&id=1ac7f132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7f132",
  null
  
)

export default component.exports